<template>
  <div class="form__group" v-if="shown">
    <div class="form__field">
      <div class="form__title" v-show="field.title">{{ field.title }}</div>
      <div class="form__breaker" v-show="field.title"></div>
      <label class="form__label" v-show="field.label" :for="identifier">
        {{ field.label }}
      </label>
    </div>
    <div class="form__breaker"></div>

    <div class="form__group">
      <component
        v-for="childField in childFields"
        :key="childField.name"
        :field="childField"
        :is="'checkout-field-' + childField.type"
      >
      </component>
    </div>
    <div class="form__breaker"></div>
    <div class="form__field">
      <div class="form__message form__message--error" v-show="field.error">
        {{ field.error }}
      </div>
      <div class="form__description" v-show="field.description">
        {{ field.description }}
      </div>
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-binded",
  data() {
    return {
      shown: window.checkoutFieldBindedShown
        ? window.checkoutFieldBindedShown
        : !this.field.defaultHidden
    };
  },
  computed: {
    childFields: function() {
      return this.field.fields.filter(field => !field.disabled);
    }
  },
  mounted() {
    window.addEventListener("onVoucherStateChange", event => {
      window.checkoutFieldBindedShown = event.detail.succeed;
      this.shown = event.detail.succeed;
      this.$forceUpdate();
    });

    let binders = this.field.binders.map(binder => {
      return {
        src: this.field.fields.find(field => field.name == binder.src),
        dest: this.field.fields.find(field => field.name == binder.dest),
        map: binder.map
      };
    });

    let updateField = () => {
      binders.forEach(binder => {
        if (Object.keys(binder.map).includes(binder.src.value)) {
          binder.dest.value = binder.map[binder.src.value];
        }
      });
    };

    this.$store.subscribe((mutation, state) => {
      if (mutation.type !== "updateField") return;
      if (!mutation.payload.newProps.value) return;
      if (!binders.map(binder => binder.src).includes(mutation.payload.field))
        return;

      updateField();
    });

    updateField();
  }
};
</script>
